import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-notice',
  standalone: true,
  imports: [],
  templateUrl: './privacy-notice.component.html',
  styleUrl: './privacy-notice.component.scss'
})
export class PrivacyNoticeComponent {

}
